import { getScrollbarSize as novaGetScrollbarSize } from '@sas/nova-commons/util/dom/getScrollbarSize';
let scrollbarSizeInvalid = true;
window.addEventListener('resize', () => {
    scrollbarSizeInvalid = true;
});
export function getScrollbarSize() {
    const size = novaGetScrollbarSize(scrollbarSizeInvalid);
    scrollbarSizeInvalid = false;
    return size;
}
